module.exports = __webpack_public_path__ + "img/haha.a4abea3f.svg";